import { render, staticRenderFns } from "./GridFilters.vue?vue&type=template&id=2a438d50"
import script from "./GridFilters.vue?vue&type=script&lang=js"
export * from "./GridFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports